import { assignSafe } from '@summit/core';
import { RoleAccess } from '../policies/role-access.enum';

export class PayRollParameters {
  managerAssistsWithPayroll: boolean = null;
  backOfficeAssistsWithPayroll: boolean = null;
  //Section Access
  vacationAccess: RoleAccess = null;
  showVacationAccrual: boolean = null;
  sickTimeAccess: RoleAccess = null;
  holidayPayAccess: RoleAccess = null;
  advanceAccess: RoleAccess = null;

  useSpecialPayrollIds: boolean = null;
  displayHourlyBreakdown: boolean = null;

  //Performance Pay
  performancePayNameLocalization: string = null;

  //Per Diem
  enablePerDiem: boolean = null;
  perDiemDailyRate: number = null;
  perDiemSoloRate: number;
  perDiemTeamRate: number;

  //Rest Break Parameters
  enableRestBreak: boolean = null;
  breakLength: number = null;
  breakInterval: number = null;
  breakMaxInDay: number = null;
  breakMaxInWeek: number = null;

  //payroll Process
  sendToProcessing: boolean = null;
  driversSeeBreakdown: boolean = null;
  breakdownShowJumps: boolean = null;
  breakdownShowDriverDraft: boolean = null;

  constructor(jsonData?: Partial<PayRollParameters>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }

  isEquivalent(other: PayRollParameters): boolean {
    return (
      this.driversSeeBreakdown === other.driversSeeBreakdown &&
      this.backOfficeAssistsWithPayroll === other.backOfficeAssistsWithPayroll &&
      this.managerAssistsWithPayroll === other.managerAssistsWithPayroll &&
      this.useSpecialPayrollIds === other.useSpecialPayrollIds &&
      this.advanceAccess === other.advanceAccess &&
      this.holidayPayAccess === other.holidayPayAccess &&
      this.sickTimeAccess === other.sickTimeAccess &&
      this.vacationAccess === other.vacationAccess &&
      this.displayHourlyBreakdown === other.displayHourlyBreakdown &&
      this.performancePayNameLocalization === other.performancePayNameLocalization &&
      this.enablePerDiem === other.enablePerDiem &&
      this.perDiemDailyRate === other.perDiemDailyRate &&
      this.enableRestBreak === other.enableRestBreak &&
      this.breakLength === other.breakLength &&
      this.breakInterval === other.breakInterval &&
      this.breakMaxInDay === other.breakMaxInDay &&
      this.breakMaxInWeek === other.breakMaxInWeek &&
      this.sendToProcessing === other.sendToProcessing &&
      this.breakdownShowJumps === other.breakdownShowJumps &&
      this.breakdownShowDriverDraft === other.breakdownShowDriverDraft &&
      this.showVacationAccrual === other.showVacationAccrual
    );
  }

  setCorporateDefaults() {
    this.backOfficeAssistsWithPayroll ??= true;
    this.managerAssistsWithPayroll ??= true;
    this.vacationAccess ??= RoleAccess.ManagerAndAbove;
    this.sickTimeAccess ??= RoleAccess.ManagerAndAbove;
    this.holidayPayAccess ??= RoleAccess.ManagerAndAbove;
    this.advanceAccess ??= RoleAccess.Payroll;
    this.driversSeeBreakdown ??= false;
    this.displayHourlyBreakdown ??= true;
    this.sendToProcessing ??= true;
    this.managerAssistsWithPayroll ??= true;
    this.backOfficeAssistsWithPayroll ??= true;
    this.breakdownShowDriverDraft ??= false;
    this.breakdownShowJumps ??= false;
    this.showVacationAccrual ??= false;
  }
}
